const CHECKOUT_ROOT_ID = 'goalmint-rc-checkout';

/** Mount point for RevenueCat Web Billing checkout (full-screen overlay). */
export function ensureRevenueCatCheckoutTarget(): HTMLElement | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  let el = document.getElementById(CHECKOUT_ROOT_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = CHECKOUT_ROOT_ID;
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.zIndex = '2147483647';
    el.style.pointerEvents = 'none';
    document.body.appendChild(el);
  }
  return el;
}

export function removeRevenueCatCheckoutTarget(): void {
  document.getElementById(CHECKOUT_ROOT_ID)?.remove();
}
